(function () {
  var VARIANT_ID = 42831941075007;
  var THRESHOLD = 15000;
  var GIFT_TITLE = 'Loungeface Lash Mascara';
  var EXCLUDED_VENDOR = 'Welridge';
  var DISMISS_KEY = 'mascara_gift_dismissed';
  var _syncing = false;
  var _debounceTimer;
  var _celebrated = false;

  function getCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  function isAutoGift(item) {
    return item.variant_id === VARIANT_ID &&
      item.properties &&
      item.properties['_gift'] === 'true';
  }

  // Counts toward the free-gift threshold only what Shopify's own
  // "Spend $150 get a FREE Mascara" discount actually qualifies on: the
  // discount's customerBuys collections cover Sun Smock, Loungeface and
  // Yupieff products only -- Welridge products are not in any of them.
  // Previously this summed every line regardless of vendor, so a cart
  // could show "you qualify!" here while Shopify's own discount engine
  // disagreed (its qualifying subtotal was really $0 from Welridge items
  // + whatever non-Welridge value was in the cart), leaving the mascara
  // charged at full price despite the UI claiming it was free.
  function subtotalExcludingGift(items) {
    return items.reduce(function (sum, item) {
      if (isAutoGift(item)) return sum;
      if (item.vendor === EXCLUDED_VENDOR) return sum;
      return sum + item.final_line_price;
    }, 0);
  }

  function findAutoGift(items) {
    return items.find(isAutoGift);
  }

  // ============================================================
  // BRAND GATE
  // The gift is never offered to a cart made up entirely of
  // Welridge items. As soon as a non-Welridge item is present,
  // normal behaviour resumes. Items already excluded for being
  // the gift itself are ignored when checking vendors.
  // ============================================================
  function cartHasNonWelridgeItem(items) {
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (isAutoGift(item)) continue;
      if (item.vendor !== EXCLUDED_VENDOR) return true;
    }
    return false;
  }

  function isDismissed() {
    try {
      return sessionStorage.getItem(DISMISS_KEY) === 'true';
    } catch (e) {
      return false;
    }
  }

  function setDismissed(value) {
    try {
      if (value) {
        sessionStorage.setItem(DISMISS_KEY, 'true');
      } else {
        sessionStorage.removeItem(DISMISS_KEY);
      }
    } catch (e) { /* storage unavailable, fail silently */ }
  }

  function cartPost(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function refreshCartDOM() {
    fetch('?section_id=helper-cart')
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var cartForm = document.getElementById('AjaxCartForm');
        var cartSubtotal = document.getElementById('AjaxCartSubtotal');
        if (cartForm && doc.getElementById('AjaxCartForm')) {
          cartForm.innerHTML = doc.getElementById('AjaxCartForm').innerHTML;
          if (typeof cartForm.ajaxifyCartItems === 'function') cartForm.ajaxifyCartItems();
        }
        if (cartSubtotal && doc.getElementById('AjaxCartSubtotal')) {
          cartSubtotal.innerHTML = doc.getElementById('AjaxCartSubtotal').innerHTML;
        }
        var countEl = cartForm && cartForm.querySelector('[data-cart-count]');
        if (countEl) {
          document.querySelectorAll('[data-header-cart-count]').forEach(function (el) {
            el.textContent = countEl.textContent;
          });
        }
        setTimeout(function () {
          getCart().then(function (cart) {
            updateUI(cart.items);
            _syncing = false;
          }).catch(function () { _syncing = false; });
        }, 400);
      })
      .catch(function () { _syncing = false; });
  }

  function addGiftAtBottom() {
    return getCart().then(function (cart) {
      var existing = findAutoGift(cart.items);
      if (existing) {
        var updates = {};
        updates[existing.key] = 0;
        return cartPost('/cart/update.js', { updates: updates });
      }
    }).then(function () {
      return cartPost('/cart/add.js', {
        id: VARIANT_ID,
        quantity: 1,
        properties: { _gift: 'true' }
      });
    }).then(function () {
      refreshCartDOM();
    });
  }

  // removedByCustomer: true when this removal came from the customer
  // clicking remove on the gift line item itself (vs. the script tidying
  // up because the cart dropped below threshold or went Welridge-only).
  // Only customer-initiated removals set the dismissal flag.
  function removeGift(key, removedByCustomer) {
    var updates = {};
    updates[key] = 0;
    return cartPost('/cart/update.js', { updates: updates })
      .then(function () {
        _celebrated = false;
        if (removedByCustomer) setDismissed(true);
        refreshCartDOM();
      });
  }

  // Customer clicked "Add free gift" after previously dismissing it.
  // Clears the dismissal flag and re-adds, returning to normal
  // auto-managed behaviour from this point on.
  function readdGift() {
    setDismissed(false);
    return addGiftAtBottom();
  }

  // ============================================================
  // CONFETTI
  // ============================================================
  function celebrate() {
    if (_celebrated) return;
    _celebrated = true;

    var canvas = document.createElement('canvas');
    canvas.style.cssText = [
      'position:fixed','top:0','left:0','width:100%','height:100%',
      'pointer-events:none','z-index:999999'
    ].join(';');
    document.body.appendChild(canvas);

    var W = canvas.width  = window.innerWidth;
    var H = canvas.height = window.innerHeight;
    var ctx = canvas.getContext('2d');

    var COLORS = [
      '#FF3366','#FF6B35','#FFD700','#00E676','#00B0FF',
      '#EA00FF','#FF1744','#FFEA00','#69F0AE','#40C4FF',
      '#E040FB','#FF4081','#CCFF90','#80D8FF','#FF80AB',
      '#ffffff','#ffe57f','#ff6d00'
    ];
    var SHAPES = ['rect','rect','rect','circle','star','ribbon'];
    var PIECE_COUNT = 200;
    var pieces = [];
    var OX = W / 2;
    var OY = H * 0.42;

    function randomColor() { return COLORS[Math.floor(Math.random() * COLORS.length)]; }
    function randomBetween(a, b) { return a + Math.random() * (b - a); }

    for (var i = 0; i < PIECE_COUNT; i++) {
      var angle = randomBetween(0, Math.PI * 2);
      var speed = randomBetween(6, 22);
      pieces.push({
        x: OX, y: OY,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed - randomBetween(4, 14),
        r: randomBetween(5, 10),
        color: randomColor(),
        shape: SHAPES[Math.floor(Math.random() * SHAPES.length)],
        rot: randomBetween(0, Math.PI * 2),
        rotSpeed: randomBetween(-0.18, 0.18),
        gravity: randomBetween(0.28, 0.55),
        drag: randomBetween(0.97, 0.995),
        wobble: randomBetween(0, Math.PI * 2),
        wobbleSpeed: randomBetween(0.05, 0.12),
        alpha: 1,
        alphaDecay: randomBetween(0.006, 0.014)
      });
    }
    for (var j = 0; j < 60; j++) {
      pieces.push({
        x: randomBetween(0, W), y: randomBetween(-60, -10),
        vx: randomBetween(-1.5, 1.5), vy: randomBetween(1.5, 3.5),
        r: randomBetween(4, 8), color: randomColor(),
        shape: SHAPES[Math.floor(Math.random() * SHAPES.length)],
        rot: randomBetween(0, Math.PI * 2), rotSpeed: randomBetween(-0.08, 0.08),
        gravity: randomBetween(0.04, 0.10), drag: 1,
        wobble: randomBetween(0, Math.PI * 2), wobbleSpeed: randomBetween(0.02, 0.06),
        alpha: 1, alphaDecay: randomBetween(0.003, 0.007)
      });
    }

    function drawStar(ctx, r) {
      var spikes = 5, outerR = r, innerR = r * 0.45, step = Math.PI / spikes;
      ctx.beginPath();
      for (var s = 0; s < spikes * 2; s++) {
        var rad = s % 2 === 0 ? outerR : innerR;
        var a = s * step - Math.PI / 2;
        if (s === 0) ctx.moveTo(Math.cos(a) * rad, Math.sin(a) * rad);
        else ctx.lineTo(Math.cos(a) * rad, Math.sin(a) * rad);
      }
      ctx.closePath();
    }

    var alive = true, frame;
    function tick() {
      ctx.clearRect(0, 0, W, H);
      var anyAlive = false;
      for (var k = 0; k < pieces.length; k++) {
        var p = pieces[k];
        if (p.alpha <= 0) continue;
        anyAlive = true;
        p.wobble += p.wobbleSpeed;
        p.vx *= p.drag;
        p.vy = p.vy * p.drag + p.gravity;
        p.x += p.vx + Math.sin(p.wobble) * 0.8;
        p.y += p.vy;
        p.rot += p.rotSpeed;
        p.alpha -= p.alphaDecay;
        if (p.y > H * 0.85) p.alpha -= 0.025;
        ctx.save();
        ctx.globalAlpha = Math.max(0, p.alpha);
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);
        ctx.fillStyle = p.color;
        if (p.shape === 'circle') { ctx.beginPath(); ctx.arc(0, 0, p.r, 0, Math.PI * 2); ctx.fill(); }
        else if (p.shape === 'star') { drawStar(ctx, p.r); ctx.fill(); }
        else if (p.shape === 'ribbon') { ctx.fillRect(-p.r * 0.3, -p.r * 1.6, p.r * 0.6, p.r * 3.2); }
        else { ctx.fillRect(-p.r, -p.r * 0.5, p.r * 2, p.r); }
        ctx.restore();
      }
      if (anyAlive && alive) { frame = requestAnimationFrame(tick); } else { canvas.remove(); }
    }
    frame = requestAnimationFrame(tick);
    setTimeout(function () { alive = false; cancelAnimationFrame(frame); canvas.remove(); }, 6000);
  }
  // ============================================================

  function updateUI(items) {
    var el        = document.getElementById('cart-gift-progress');
    var msg       = document.getElementById('gift-progress-message');
    var bar       = document.getElementById('gift-progress-bar');
    var barWrap   = document.getElementById('gift-progress-bar-wrap');
    var readdWrap = document.getElementById('gift-readd-wrap');
    if (!el) return;

    var eligible   = cartHasNonWelridgeItem(items);
    var hasGift    = !!findAutoGift(items);
    var subtotal   = subtotalExcludingGift(items);

    // Welridge-only cart: hide the gift module entirely, regardless of subtotal.
    if (!eligible) {
      el.style.display = 'none';
      return;
    }

    el.style.display = 'block';

    // Dismissed, still eligible, still over threshold, gift not present:
    // show the manual re-add affordance instead of the progress bar.
    if (subtotal >= THRESHOLD && !hasGift && isDismissed()) {
      if (barWrap) barWrap.style.display = 'none';
      if (readdWrap) readdWrap.style.display = 'flex';
      return;
    }

    if (barWrap) barWrap.style.display = 'block';
    if (readdWrap) readdWrap.style.display = 'none';

    if (subtotal >= THRESHOLD) {
      bar.style.width = '100%';
      msg.innerHTML = '<strong>✓ You\'ve unlocked a free ' + GIFT_TITLE + '!</strong>';
      if (hasGift) celebrate();
    } else {
      _celebrated = false;
      var remaining = THRESHOLD - subtotal;
      var dollars   = (remaining / 100).toFixed(2);
      var pct       = Math.min(Math.round((subtotal / THRESHOLD) * 100), 99);
      bar.style.width = pct + '%';
      msg.innerHTML = 'Spend <strong>$' + dollars + ' AUD more</strong> to receive a free ' + GIFT_TITLE + '.';
    }
  }

  function syncGift() {
    if (_syncing) return Promise.resolve();
    _syncing = true;

    return getCart().then(function (cart) {
      var items      = cart.items;
      var giftItem   = findAutoGift(items);
      var subtotal   = subtotalExcludingGift(items);
      var eligible   = cartHasNonWelridgeItem(items);

      updateUI(items);

      // Cart is Welridge-only: strip the gift if it's somehow present
      // (e.g. customer removed all non-Welridge items after qualifying)
      // and never auto-add, regardless of dismissal state.
      if (!eligible) {
        if (giftItem) {
          return removeGift(giftItem.key, false).catch(function () { _syncing = false; });
        }
        _syncing = false;
        return;
      }

      // Customer explicitly removed the gift this session: leave it off
      // until they either click "Add free gift" manually, or the cart
      // drops below threshold and crosses it again.
      if (subtotal >= THRESHOLD && !giftItem && isDismissed()) {
        _syncing = false;
        return;
      }

      if (subtotal >= THRESHOLD && !giftItem) {
        return addGiftAtBottom().catch(function () { _syncing = false; });
      } else if (subtotal >= THRESHOLD && giftItem) {
        var lastItem = items[items.length - 1];
        if (!isAutoGift(lastItem)) {
          var updates = {};
          updates[giftItem.key] = 0;
          return cartPost('/cart/update.js', { updates: updates })
            .then(function () { return cartPost('/cart/add.js', { id: VARIANT_ID, quantity: 1, properties: { _gift: 'true' } }); })
            .then(function () { refreshCartDOM(); })
            .catch(function () { _syncing = false; });
        } else {
          _syncing = false;
        }
      } else if (subtotal < THRESHOLD && giftItem) {
        // Dropped below threshold organically (not a customer dismissal).
        // Clear any prior dismissal so re-crossing the threshold re-offers
        // the gift normally.
        setDismissed(false);
        return removeGift(giftItem.key, false).catch(function () { _syncing = false; });
      } else if (subtotal < THRESHOLD && !giftItem) {
        setDismissed(false);
        _syncing = false;
      } else {
        _syncing = false;
      }
    }).catch(function () { _syncing = false; });
  }

  function debouncedSync() {
    clearTimeout(_debounceTimer);
    _debounceTimer = setTimeout(syncGift, 200);
  }

  // ============================================================
  // MANUAL RE-ADD BUTTON
  // ============================================================
  function attachReaddButton() {
    var btn = document.getElementById('gift-readd-button');
    if (!btn || btn.dataset.readdAttached) return;
    btn.dataset.readdAttached = 'true';

    btn.addEventListener('click', function () {
      btn.disabled = true;
      readdGift().catch(function () { _syncing = false; }).finally(function () {
        btn.disabled = false;
      });
    });
  }

  // ============================================================
  // CUSTOMER-INITIATED REMOVAL DETECTION
  // Cart line-item remove buttons typically trigger a normal cart
  // update flow. We detect a customer removing the auto-gift line
  // specifically by diffing cart state before/after any cart-updated
  // event: if the gift was present before and absent after, and the
  // subtotal is still >= threshold, that removal was customer-driven
  // (the script itself never removes the gift while still above
  // threshold), so we mark it dismissed.
  // ============================================================
  var _lastKnownGiftPresent = null;
  var _lastKnownSubtotal = null;

  function detectManualRemoval() {
    getCart().then(function (cart) {
      var giftItem   = findAutoGift(cart.items);
      var subtotal   = subtotalExcludingGift(cart.items);
      var eligible   = cartHasNonWelridgeItem(cart.items);

      if (
        eligible &&
        _lastKnownGiftPresent === true &&
        !giftItem &&
        subtotal >= THRESHOLD
      ) {
        setDismissed(true);
      }

      _lastKnownGiftPresent = !!giftItem;
      _lastKnownSubtotal = subtotal;
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    attachReaddButton();
    getCart().then(function (cart) {
      _lastKnownGiftPresent = !!findAutoGift(cart.items);
      _lastKnownSubtotal = subtotalExcludingGift(cart.items);
      syncGift();
    });
  });

  document.addEventListener('cart-updated', function () {
    detectManualRemoval();
    debouncedSync();
  });

  var observer = new MutationObserver(function () {
    attachReaddButton();
    detectManualRemoval();
    debouncedSync();
  });
  function attachObserver() {
    var el = document.getElementById('AjaxCartSubtotal');
    if (el) { observer.observe(el, { childList: true, subtree: true, characterData: true }); }
    else { setTimeout(attachObserver, 500); }
  }
  attachObserver();

  // ============================================================
  // CHECKOUT GUARD
  // Only intervenes when the gift state could actually be wrong:
  // subtotal >= threshold but no gift yet and not dismissed, or
  // subtotal < threshold but gift still present, or cart is now
  // Welridge-only but the gift is still present, or a sync is
  // currently mid-flight. A dismissed-but-eligible cart (manual
  // re-add available) is a valid state and does not block checkout.
  // In the vast majority of checkouts this adds zero delay -- one
  // quick /cart.js read, then immediate submit.
  // ============================================================
  function guardCheckoutButton() {
    var btn = document.getElementById('mu-checkout-button');
    if (!btn || btn.dataset.giftGuardAttached) return;
    btn.dataset.giftGuardAttached = 'true';

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var form = document.getElementById('cart') || btn.closest('form');

      function proceedToCheckout() {
        if (form) {
          form.submit();
        } else {
          window.location.href = '/checkout';
        }
      }

      getCart().then(function (cart) {
        var items      = cart.items;
        var giftItem   = findAutoGift(items);
        var subtotal   = subtotalExcludingGift(items);
        var eligible   = cartHasNonWelridgeItem(items);

        var giftStateWrong =
          (!eligible && !!giftItem) ||
          (eligible && subtotal >= THRESHOLD && !giftItem && !isDismissed()) ||
          (subtotal < THRESHOLD && !!giftItem);

        if (!giftStateWrong && !_syncing) {
          proceedToCheckout();
          return;
        }

        var originalText = btn.querySelector('.button__text');
        var originalLabel = originalText ? originalText.textContent : null;

        clearTimeout(_debounceTimer);

        var settled = false;
        var maxWait = setTimeout(function () {
          if (!settled) {
            settled = true;
            if (originalText && originalLabel) originalText.textContent = originalLabel;
            btn.disabled = false;
            proceedToCheckout();
          }
        }, 2000);

        if (originalText) originalText.textContent = 'Checking your gift…';
        btn.disabled = true;

        syncGift().then(finish).catch(finish);

        function finish() {
          if (!settled) {
            settled = true;
            clearTimeout(maxWait);
            if (originalText && originalLabel) originalText.textContent = originalLabel;
            btn.disabled = false;
            proceedToCheckout();
          }
        }
      }).catch(function () {
        proceedToCheckout();
      });
    }, true);
  }

  guardCheckoutButton();
  var checkoutObserver = new MutationObserver(function () { guardCheckoutButton(); });
  checkoutObserver.observe(document.body, { childList: true, subtree: true });
})();
